import { create } from 'zustand';

interface StockPhotosState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useStockPhotosStore = create<StockPhotosState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
